/**
 * Rusty Fox Co. - Customer Reviews Page Interactive Engine
 * High-Performance Pinterest-Style Multi-Column Masonry Grid, Lightbox & Load-More
 */

(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // 1. SHARED LIGHTBOX CONTROLLER
  // ---------------------------------------------------------------------------
  const lightboxEl = document.getElementById('rfc-lightbox');
  const lightboxImg = document.getElementById('rfc-lightbox-img');
  const lightboxAuthor = document.getElementById('rfc-lightbox-author');
  const lightboxDate = document.getElementById('rfc-lightbox-date');
  const lightboxStars = document.getElementById('rfc-lightbox-stars');
  const lightboxContent = document.getElementById('rfc-lightbox-content');
  const lightboxProductLink = document.getElementById('rfc-lightbox-product-link');
  const lightboxProductThumb = document.getElementById('rfc-lightbox-product-thumb');
  const lightboxProductTitle = document.getElementById('rfc-lightbox-product-title');
  const lightboxClose = document.getElementById('rfc-lightbox-close');
  const lightboxPrev = document.getElementById('rfc-lightbox-prev');
  const lightboxNext = document.getElementById('rfc-lightbox-next');

  let activeLightboxIndex = -1;
  let activeLightboxList = [];

  function renderStarsSvg(count) {
    const star = `<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>`;
    let html = '<div class="rfc-stars rfc-card__stars">';
    for (let i = 0; i < count; i++) {
      html += star;
    }
    html += '</div>';
    return html;
  }

  function formatDateDisplay(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  }

  function escapeHtml(text) {
    if (!text) return '';
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function openLightbox(list, index) {
    if (!list || index < 0 || index >= list.length) return;
    activeLightboxList = list;
    activeLightboxIndex = index;
    const item = list[index];
    if (!item) return;

    const imgUrl = (item.images && item.images.length > 0) ? item.images[0] : '';
    if (!imgUrl) return;

    if (lightboxImg) lightboxImg.src = imgUrl;
    if (lightboxAuthor) lightboxAuthor.textContent = item.author || 'Verified Buyer';
    if (lightboxDate) lightboxDate.textContent = formatDateDisplay(item.date);
    if (lightboxStars) lightboxStars.innerHTML = renderStarsSvg(item.rating || 5);
    if (lightboxContent) lightboxContent.textContent = item.content || '';

    if (lightboxProductLink && lightboxProductTitle) {
      lightboxProductLink.href = item.productUrl || '#';
      lightboxProductTitle.textContent = item.productTitle || '';
      if (lightboxProductThumb && item.productImage) {
        lightboxProductThumb.src = item.productImage;
        lightboxProductThumb.style.display = 'block';
      } else if (lightboxProductThumb) {
        lightboxProductThumb.style.display = 'none';
      }
    }

    if (lightboxEl) {
      lightboxEl.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeLightbox() {
    if (lightboxEl) {
      lightboxEl.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    activeLightboxIndex = -1;
  }

  function prevLightbox() {
    if (!activeLightboxList.length) return;
    if (activeLightboxIndex <= 0) {
      openLightbox(activeLightboxList, activeLightboxList.length - 1);
    } else {
      openLightbox(activeLightboxList, activeLightboxIndex - 1);
    }
  }

  function nextLightbox() {
    if (!activeLightboxList.length) return;
    if (activeLightboxIndex >= activeLightboxList.length - 1) {
      openLightbox(activeLightboxList, 0);
    } else {
      openLightbox(activeLightboxList, activeLightboxIndex + 1);
    }
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function (e) { e.stopPropagation(); prevLightbox(); });
  if (lightboxNext) lightboxNext.addEventListener('click', function (e) { e.stopPropagation(); nextLightbox(); });
  if (lightboxEl) {
    lightboxEl.addEventListener('click', function (e) {
      if (e.target === lightboxEl) closeLightbox();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (!lightboxEl || !lightboxEl.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') prevLightbox();
    if (e.key === 'ArrowRight') nextLightbox();
  });

  // ---------------------------------------------------------------------------
  // 2. HELPER: CREATE REVIEW CARD ELEMENT WITH NATURAL ASPECT-RATIO
  // ---------------------------------------------------------------------------
  function createCardElement(item, itemIndex, animDelay) {
    const card = document.createElement('div');
    card.className = 'rfc-review-card animate-in';
    if (animDelay > 0) {
      card.style.animationDelay = `${animDelay}ms`;
    }
    card.setAttribute('data-review-id', item.id);
    card.setAttribute('data-list-index', itemIndex);

    const hasImg = item.images && item.images.length > 0;
    const firstImg = hasImg ? item.images[0] : '';
    const initialLetter = item.author ? item.author.charAt(0).toUpperCase() : 'C';

    let aspectStyle = '';
    if (hasImg && firstImg) {
      const wMatch = firstImg.match(/[?&]w=(\d+)/);
      const hMatch = firstImg.match(/[?&]h=(\d+)/);
      if (wMatch && hMatch) {
        aspectStyle = `style="aspect-ratio: ${wMatch[1]} / ${hMatch[1]};"`;
      }
    }

    let mediaHtml = '';
    if (hasImg) {
      mediaHtml = `
        <div class="rfc-card__media-wrapper js-card-media" data-index="${itemIndex}" ${aspectStyle}>
          <img class="rfc-card__image" src="${escapeHtml(firstImg)}" alt="Feedback photo from ${escapeHtml(item.author)}" loading="lazy" ${aspectStyle} />
          <div class="rfc-card__media-overlay">
            <span class="rfc-card__zoom-icon" title="Click to enlarge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="11" y1="8" x2="11" y2="14"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
              </svg>
            </span>
          </div>
          ${item.images.length > 1 ? `<span class="rfc-card__photos-count">${item.images.length} photos</span>` : ''}
        </div>
      `;
    }

    let productFooterHtml = '';
    if (item.productTitle) {
      productFooterHtml = `
        <div class="rfc-card__product-footer">
          <a href="${escapeHtml(item.productUrl)}" class="rfc-card__product-link" title="${escapeHtml(item.productTitle)}">
            ${item.productImage ? `<img class="rfc-card__product-thumb" src="${escapeHtml(item.productImage)}" alt="${escapeHtml(item.productTitle)}" loading="lazy" />` : ''}
            <span class="rfc-card__product-title">${escapeHtml(item.productTitle)}</span>
            <span class="rfc-card__product-arrow">&rarr;</span>
          </a>
        </div>
      `;
    }

    card.innerHTML = `
      ${mediaHtml}
      <div class="rfc-card__body">
        <div class="rfc-card__author-row">
          <div class="rfc-card__author-info">
            <div class="rfc-card__avatar">${initialLetter}</div>
            <div class="rfc-card__name">${escapeHtml(item.author)}</div>
          </div>
          <div class="rfc-card__date">${formatDateDisplay(item.date)}</div>
        </div>
        <div class="rfc-card__rating-row">
          ${renderStarsSvg(item.rating || 5)}
          <span class="rfc-card__badge-verified">
            <svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
            Verified Buyer
          </span>
        </div>
        <div class="rfc-card__content">
          ${escapeHtml(item.content)}
        </div>
        ${productFooterHtml}
      </div>
    `;

    return card;
  }

  // ---------------------------------------------------------------------------
  // 3. CONTAINER INITIALIZATION (PER REVIEWS SECTION)
  // ---------------------------------------------------------------------------
  function initReviewsContainer(container) {
    if (!container) return;
    if (container.getAttribute('data-masonry-initialized') === 'true') return;
    container.setAttribute('data-masonry-initialized', 'true');

    const gridEl = container.querySelector('.rfc-masonry-grid');
    if (!gridEl) return;

    const rawData = window.RFC_REVIEWS_DATA || [];
    if (!rawData.length) return;

    const isCompact = container.getAttribute('data-compact') === 'true';
    const INITIAL_BATCH = isCompact ? parseInt(container.getAttribute('data-initial') || '4', 10) : 16;
    const LOAD_MORE_BATCH = isCompact ? parseInt(container.getAttribute('data-step') || '4', 10) : 12;

    const loadMoreBtn = container.querySelector('.rfc-btn-load-more, .rfc-btn-show-more');
    const progressTextEl = container.querySelector('.rfc-progress-text');
    const progressFillEl = container.querySelector('.rfc-progress-fill');
    const allLoadedNoticeEl = container.querySelector('.rfc-all-loaded-notice');
    const tabBtns = container.querySelectorAll('.rfc-tab-btn');
    const sortSelect = container.querySelector('.rfc-sort-select');

    let currentFilter = 'all';
    let currentSort = 'newest';
    let currentFilteredList = [...rawData];
    let displayedCount = 0;
    let cols = [];
    let currentColCount = 0;

    function getTargetColCount() {
      const w = window.innerWidth;
      if (w >= 990) return 4;
      if (w >= 750) return 3;
      if (w >= 480) return 2;
      return 1;
    }

    function setupColumns(count) {
      gridEl.innerHTML = '';
      cols = [];
      currentColCount = count;
      for (let i = 0; i < count; i++) {
        const col = document.createElement('div');
        col.className = 'rfc-masonry-col';
        gridEl.appendChild(col);
        cols.push(col);
      }
    }

    function appendCardToGrid(card) {
      if (!cols.length) setupColumns(getTargetColCount());

      // 1. If any column is currently empty, slot into the first empty column from left to right
      let targetCol = cols.find(c => c.children.length === 0);

      // 2. If all columns have at least one card, slot into whichever column has the smallest height
      if (!targetCol) {
        let minH = Infinity;
        for (let i = 0; i < cols.length; i++) {
          const h = cols[i].offsetHeight;
          if (h < minH) {
            minH = h;
            targetCol = cols[i];
          }
        }
      }

      if (targetCol) {
        targetCol.appendChild(card);
      } else if (cols[0]) {
        cols[0].appendChild(card);
      }
    }

    function updateProgressAndControls() {
      const total = currentFilteredList.length;
      if (progressTextEl) {
        progressTextEl.textContent = `Showing ${displayedCount} of ${total} reviews`;
      }
      if (progressFillEl) {
        const pct = total > 0 ? Math.min(100, Math.round((displayedCount / total) * 100)) : 100;
        progressFillEl.style.width = `${pct}%`;
      }

      if (displayedCount >= total) {
        if (loadMoreBtn) loadMoreBtn.style.display = 'none';
        if (allLoadedNoticeEl) allLoadedNoticeEl.style.display = 'inline-flex';
      } else {
        if (loadMoreBtn) loadMoreBtn.style.display = 'inline-flex';
        if (allLoadedNoticeEl) allLoadedNoticeEl.style.display = 'none';
      }
    }

    function loadNextBatch(batchSize) {
      const total = currentFilteredList.length;
      if (displayedCount >= total) {
        updateProgressAndControls();
        return;
      }

      const nextItems = currentFilteredList.slice(displayedCount, displayedCount + batchSize);

      nextItems.forEach((item, idx) => {
        const itemGlobalIndex = displayedCount + idx;
        const animDelay = (idx % currentColCount) * 40;
        const card = createCardElement(item, itemGlobalIndex, animDelay);
        appendCardToGrid(card);
      });

      displayedCount += nextItems.length;
      updateProgressAndControls();
    }

    function applyFilterAndSort() {
      // 1. Filter
      if (currentFilter === 'all') {
        currentFilteredList = [...rawData];
      } else if (currentFilter === 'photos') {
        currentFilteredList = rawData.filter(r => r.images && r.images.length > 0);
      } else if (currentFilter === '5star') {
        currentFilteredList = rawData.filter(r => r.rating === 5);
      } else if (currentFilter === '4star') {
        currentFilteredList = rawData.filter(r => r.rating === 4);
      }

      // 2. Sort
      if (currentSort === 'newest') {
        currentFilteredList.sort((a, b) => new Date(b.date) - new Date(a.date));
      } else if (currentSort === 'oldest') {
        currentFilteredList.sort((a, b) => new Date(a.date) - new Date(b.date));
      } else if (currentSort === 'highest') {
        currentFilteredList.sort((a, b) => (b.rating || 5) - (a.rating || 5));
      }

      // Reset columns & render initial
      setupColumns(getTargetColCount());
      displayedCount = 0;
      loadNextBatch(INITIAL_BATCH);
    }

    function rebuildGrid(newColCount) {
      if (displayedCount === 0) return;
      const renderedItems = currentFilteredList.slice(0, displayedCount);
      setupColumns(newColCount);
      renderedItems.forEach((item, idx) => {
        const card = createCardElement(item, idx, 0);
        appendCardToGrid(card);
      });
    }

    // Window resize listener
    let resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const targetCols = getTargetColCount();
        if (targetCols !== currentColCount) {
          rebuildGrid(targetCols);
        }
      }, 150);
    });

    // 1. Load More / Show More Button
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        loadMoreBtn.classList.add('is-loading');
        loadMoreBtn.disabled = true;

        setTimeout(function () {
          loadNextBatch(LOAD_MORE_BATCH);
          loadMoreBtn.classList.remove('is-loading');
          loadMoreBtn.disabled = false;
        }, 180);
      });
    }

    // 2. Filter Tabs
    tabBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        tabBtns.forEach(b => b.classList.remove('is-active'));
        this.classList.add('is-active');
        currentFilter = this.getAttribute('data-filter') || 'all';
        applyFilterAndSort();
      });
    });

    // 3. Sort Select
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        currentSort = this.value;
        applyFilterAndSort();
      });
    }

    // 4. Click on Grid (Lightbox Trigger)
    gridEl.addEventListener('click', function (e) {
      const mediaTrigger = e.target.closest('.js-card-media');
      if (mediaTrigger) {
        const card = mediaTrigger.closest('.rfc-review-card');
        const reviewId = card ? card.getAttribute('data-review-id') : null;
        let index = -1;
        if (reviewId) {
          index = currentFilteredList.findIndex(r => r.id === reviewId);
        }
        if (index === -1) {
          index = parseInt(mediaTrigger.getAttribute('data-index'), 10);
        }
        if (index >= 0 && index < currentFilteredList.length) {
          openLightbox(currentFilteredList, index);
        }
      }
    });

    // 5. Click on star bar rows to filter (in scorecard)
    const starRows = container.querySelectorAll('.rfc-bar-row[data-star-filter]');
    starRows.forEach(row => {
      row.addEventListener('click', function () {
        const star = this.getAttribute('data-star-filter');
        const filterVal = star === '5' ? '5star' : (star === '4' ? '4star' : 'all');

        tabBtns.forEach(b => {
          if (b.getAttribute('data-filter') === filterVal) {
            b.classList.add('is-active');
          } else {
            b.classList.remove('is-active');
          }
        });
        currentFilter = filterVal;
        applyFilterAndSort();

        if (gridEl) {
          gridEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // 6. Animate Scorecard Bars & Counters
    function animateScorecardBars() {
      const barFills = container.querySelectorAll('.rfc-bar-fill');
      barFills.forEach(fill => {
        const targetPercent = fill.getAttribute('data-percent') || '0%';
        fill.style.width = '0%';
        setTimeout(() => {
          fill.style.width = targetPercent;
        }, 120);
      });

      const counters = container.querySelectorAll('.js-counter');
      counters.forEach(counter => {
        const target = parseInt(counter.getAttribute('data-target') || '0', 10);
        if (target === 0) {
          counter.textContent = '0';
          return;
        }
        let current = 0;
        const step = Math.max(1, Math.floor(target / 25));
        const timer = setInterval(() => {
          current += step;
          if (current >= target) {
            current = target;
            clearInterval(timer);
          }
          counter.textContent = current;
        }, 22);
      });
    }

    // 7. Write a Review button trigger
    const writeReviewBtns = container.querySelectorAll('.rfc-btn-write-review');
    writeReviewBtns.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const jdgmWriteBtn = document.querySelector('.jdgm-write-rev-link, .jdgm-widget-actions-wrapper a');
        if (jdgmWriteBtn) {
          jdgmWriteBtn.click();
          jdgmWriteBtn.scrollIntoView({ behavior: 'smooth' });
        } else {
          const jdgmSection = document.getElementById('judgeme_all_reviews_section');
          if (jdgmSection) {
            jdgmSection.scrollIntoView({ behavior: 'smooth' });
          } else {
            alert('To leave a review, please open any product page you purchased and submit your review via the Judge.me review form. Thank you!');
          }
        }
      });
    });

    // Initial render for this container
    applyFilterAndSort();
    animateScorecardBars();
  }

  // ---------------------------------------------------------------------------
  // 4. MAIN ENTRY POINT & RETRY FOR ASYNC DATA
  // ---------------------------------------------------------------------------
  function initAllReviews() {
    const rawData = window.RFC_REVIEWS_DATA || [];
    if (!rawData.length) {
      let retries = 0;
      const timer = setInterval(() => {
        retries++;
        if (window.RFC_REVIEWS_DATA && window.RFC_REVIEWS_DATA.length) {
          clearInterval(timer);
          initAllReviews();
        } else if (retries > 30) {
          clearInterval(timer);
          console.warn('[RFC Reviews] Timed out waiting for reviews data.');
        }
      }, 70);
      return;
    }

    const containers = document.querySelectorAll('.rfc-reviews-container');
    if (containers.length > 0) {
      containers.forEach(c => initReviewsContainer(c));
    } else {
      // Fallback if container class is absent
      const fallbackGrid = document.getElementById('rfc-masonry-grid');
      if (fallbackGrid) {
        const parent = fallbackGrid.parentElement || document.body;
        initReviewsContainer(parent);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllReviews);
  } else {
    initAllReviews();
  }
})();
